import { gql } from '@grandvisionhq/graphql';
import { recreateOrderedCheckoutFailure } from './recreate-ordered-checkout-failure.js';

const recreateOrderedCheckoutResult = gql`
  fragment RecreateOrderedCheckoutFragment on OrderedCheckoutResponse {
    newCheckoutId
    checkoutHash
    failures {
      ...RecreateOrderedCheckoutFailureFragment
    }
    success
  }
  ${recreateOrderedCheckoutFailure}
`;

export { recreateOrderedCheckoutResult };
//# sourceMappingURL=recreate-ordered-checkout-result.js.map
